<template>
  <div class="content">
    <h4>Zaloguj się</h4>
    <form>
      <div class="input-field">
        <custom-input
            v-model="username"
            placeholder="Użytkownik"
            required
            type="text"
        />
        <p
            class="error-msg"
            v-if="msg.username"
        >
          {{ msg.username }}
        </p>
      </div>
      <div class="input-field">
        <custom-input
            v-model="password"
            placeholder="Hasło"
            required
            type="password"
        />
        <p
            class="error-msg"
            v-if="msg.password"
        >
          {{ msg.password }}
        </p>
      </div>
    </form>
    <custom-button
        class="login-button"
        button-name="Zaloguj"
        @click="sendLoginRequest"
        :disabled="buttonDisabled"
    />
    <div class="text-button">
      <div
          class="small-text"
          @click="$emit('forgot-password')"
      >
        Zapomniałem hasła
      </div>
    </div>
    <p v-if="statusCode === 401" class="error-msg">
      Nieprawidłowa nazwa użytkownika lub hasło.
    </p>
  </div>
</template>

<script>
import { reactive, ref } from 'vue';

import { login } from '../../plugins/auth';

import CustomInput from '../common/CustomInput.vue';
import CustomButton from '../common/CustomButton.vue';

export default {
  name: 'loginForm',

  components: { CustomButton, CustomInput },

  setup() {
    const username = ref('');
    const password = ref('');
    const statusCode = ref();

    const msg = reactive({
      username: '',
      password: '',
    });

    function validationForm() {
      msg.username = '';
      msg.password = '';
      statusCode.value = null;

      if (!username.value) {
        msg.username = 'Pole "użytkownik" nie może być puste.';
      }
      if (!password.value) {
        msg.password += 'Pole "hasło" nie może być puste.';
      }
      return (!msg.username && !msg.password);
    }

    const buttonDisabled = ref(false);

    async function sendLoginRequest() {
      buttonDisabled.value = true;
      if (validationForm()) {
        const payload = {
          username: username.value,
          password: password.value,
        };
        statusCode.value = await login(payload);
      }
      buttonDisabled.value = false;
    }

    function enterButtonListener(e) {
      if (e.key === 'Enter') sendLoginRequest();
    }

    window.addEventListener('keydown', enterButtonListener);

    return {
      buttonDisabled,
      sendLoginRequest,
      msg,
      password,
      statusCode,
      username,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/colors.scss';
@import '../../assets/css/errors.scss';

.content {
  height: 265px;

  h4 {
    color: $dark-grey;
    margin: 20px;
    text-align: center;
  }

  .input-field {
    margin-bottom: 20px;
  }

  .login-button {
    border-radius: 5px;
    width: 300px;
    height: 40px;
    border: 1px solid $light-green;
    background-color: $light-green;
    color: white;
  }

  .text-button {
    display: flex;
    width: 300px;
    justify-content: flex-end;

    .small-text {
      color: $light-green;
      cursor: pointer;
      margin-top: 8px;
      font-size: 14px;
    }
  }
}
</style>
